export class Holiday {
  constructor(
    public targetDate: Date,
    public comment: string,
    public isDeleted: boolean,
  ) {
  }
}
